import AInsightSuccessRateDrawer from './AInsight/ServiceExperience/SuccessRateDrawer';
import AInsightAuthTimeDrawer from './AInsight/ServiceExperience/AuthTimeDrawer';
import AInsightSatisfactionDrawer from './AInsight/ServiceExperience/SatisfactionDrawer';
import AInsightDeviceRebootDrawer from './AInsight/Operations/DeviceRebootDrawer';
import AInsightPoEFaultDrawer from './AInsight/Operations/PoEFaultDrawer';
import AInsightUplinkStabilityDrawer from './AInsight/Operations/UplinkStabilityDrawer';
import AInsightSystemPerformanceDrawer from './AInsight/Operations/SystemPerformanceDrawer';
import AInsightFirmwareUpdateDrawer from './AInsight/Operations/FirmwareUpdateDrawer';
import AInsightRoamDrawer from './AInsight/Roam/RoamDrawer';
import AInsightWirelessCoverageDrawer from './AInsight/WirelessCoverage/WirelessCoverageDrawer';
import AinsightRogueAPDetectionDrawer from './AInsight/Security/RogueAPDetectionDrawer';
import AinsightAbnormalLocationAndAssestDisplacementDrawer from './AInsight/Security/AbnormalLocationAndAssestDisplacementDrawer';
import AinsightWirelessCongestionLevelDrawer from './AInsight/LinkIntegrity/WirelessCongestionLevelDrawer';
import AinsightWiredCongestionLevelDrawer from './AInsight/LinkIntegrity/WiredCongestionLevelDrawer';
import AinsightWiredLinkDegradationDrawer from './AInsight/LinkIntegrity/WiredLinkDegradationDrawer';
import AinsightWiredCableQualityDrawer from './AInsight/LinkIntegrity/WiredCableQualityDrawer';
import AinsightWirelessChannelInterfaceDrawer from './AInsight/LinkIntegrity/WirelessChannelInterfaceDrawer';
import DevicesContent from './Devices';
import UsersContent from './Users';
import ClientContent from './Clients';
import SettingsWirelessSsid from './Settings/Wireless/SSID';
import SettingsProfilePort from './Settings/Profiles/Port';
import SettingsCaptivePortal from './Settings/CaptivePortal';
import SettingsWiredConfigProvisioning from './Settings/Wired/ConfigProvisioning';

const drawerContentConfig = {
  ainsightSuccessRateDrawer: AInsightSuccessRateDrawer,
  ainsightAuthTimeDrawer: AInsightAuthTimeDrawer,
  ainsightSatisfactionDrawer: AInsightSatisfactionDrawer,
  ainsightDeviceRebootDrawer: AInsightDeviceRebootDrawer,
  ainsightPoEFaultDrawer: AInsightPoEFaultDrawer,
  ainsightUplinkStabilityDrawer: AInsightUplinkStabilityDrawer,
  ainsightSystemPerformanceDrawer: AInsightSystemPerformanceDrawer,
  ainsightFirmwareUpdateDrawer: AInsightFirmwareUpdateDrawer,
  ainsightRoamDrawer: AInsightRoamDrawer,
  ainsightWirelessCoverageDrawer: AInsightWirelessCoverageDrawer,
  ainsightRogueAPDetectionDrawer: AinsightRogueAPDetectionDrawer,
  ainsightAbnormalLocationAndAssestDisplacementDrawer: AinsightAbnormalLocationAndAssestDisplacementDrawer,
  ainsightWirelessCongestionLevelDrawer: AinsightWirelessCongestionLevelDrawer,
  ainsightWiredCongestionLevelDrawer: AinsightWiredCongestionLevelDrawer,
  ainsightWiredLinkDegradationDrawer: AinsightWiredLinkDegradationDrawer,
  ainsightWiredCableQualityDrawer: AinsightWiredCableQualityDrawer,
  ainsightWirelessChannelInterfaceDrawer: AinsightWirelessChannelInterfaceDrawer,
  devices: DevicesContent,
  users: UsersContent,
  clients: ClientContent,
  settingsWirelessSsid: SettingsWirelessSsid,
  settingsProfilePort: SettingsProfilePort,
  settingsCaptivePortal: SettingsCaptivePortal,
  settingsWiredConfigProvisioning: SettingsWiredConfigProvisioning,
};

export default drawerContentConfig;
